import { instance } from "..";

// Public: one visit through a campaign link (/go/:slug or a page with
// ?c=slug). body = { slug, visitorId, referrer?, test? }; `test: true` counts
// nothing. Returns { found, active?, counted?, destination } — destination is
// a same-site path ("/" for an unknown link).
export const openCampaignLink = async (body) => {
  const { data } = await instance.post("/api/go/open", body);
  return data;
};

// Signed in: credit this account with every campaign link this browser came
// through in the last 30 days. Safe to repeat. Returns { attached }.
export const attachCampaign = async (visitorId) => {
  const { data } = await instance.post("/api/go/attach", { visitorId });
  return data;
};
